import { d as dispatchToTrackersInCollection, g as getFilterByClass, a as buildLinkClick, c as addEventListener, e as getHostName, f as getCssClasses, r as resolveDynamicContext } from "./index-26c1728a.js";
/*!
 * Link Click tracking for Snowplow v3.23.0 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */
var _trackers = {};
var _configuration = {};
function LinkClickTrackingPlugin() {
  return {
    activateBrowserPlugin: function(tracker) {
      _trackers[tracker.id] = tracker;
    }
  };
}
function enableLinkClickTracking(configuration, trackers) {
  if (configuration === void 0) {
    configuration = {};
  }
  if (trackers === void 0) {
    trackers = Object.keys(_trackers);
  }
  trackers.forEach(function(id) {
    if (_trackers[id]) {
      if (_trackers[id].sharedState.hasLoaded) {
        configureLinkClickTracking(configuration, id);
        addClickListeners(id);
      } else {
        _trackers[id].sharedState.registeredOnLoadHandlers.push(function() {
          configureLinkClickTracking(configuration, id);
          addClickListeners(id);
        });
      }
    }
  });
}
function refreshLinkClickTracking(trackers) {
  if (trackers === void 0) {
    trackers = Object.keys(_trackers);
  }
  trackers.forEach(function(id) {
    if (_trackers[id]) {
      if (_trackers[id].sharedState.hasLoaded) {
        addClickListeners(id);
      } else {
        _trackers[id].sharedState.registeredOnLoadHandlers.push(function() {
          addClickListeners(id);
        });
      }
    }
  });
}
function trackLinkClick(event, trackers) {
  if (trackers === void 0) {
    trackers = Object.keys(_trackers);
  }
  dispatchToTrackersInCollection(trackers, _trackers, function(t) {
    t.core.track(buildLinkClick(event), event.context, event.timestamp);
  });
}
function processClick(tracker, sourceElement, context) {
  var parentElement, tag, elementId, elementClasses, elementTarget, elementContent;
  while ((parentElement = sourceElement.parentElement) !== null && parentElement != null && (tag = sourceElement.tagName.toUpperCase()) !== "A" && tag !== "AREA") {
    sourceElement = parentElement;
  }
  var anchorElement = sourceElement;
  if (anchorElement.href != null) {
    var originalSourceHostName = anchorElement.hostname || getHostName(anchorElement.href), sourceHostName = originalSourceHostName.toLowerCase(), sourceHref = anchorElement.href.replace(originalSourceHostName, sourceHostName), scriptProtocol = new RegExp("^(javascript|vbscript|jscript|mocha|livescript|ecmascript):", "i");
    if (!scriptProtocol.test(sourceHref)) {
      elementId = anchorElement.id;
      elementClasses = getCssClasses(anchorElement);
      elementTarget = anchorElement.target;
      elementContent = _configuration[tracker.id].linkTrackingContent ? anchorElement.innerHTML : void 0;
      sourceHref = unescape(sourceHref);
      tracker.core.track(buildLinkClick({
        targetUrl: sourceHref,
        elementId,
        elementClasses,
        elementTarget,
        elementContent
      }), resolveDynamicContext(context, sourceElement));
    }
  }
}
function getClickHandler(tracker, context) {
  return function(evt) {
    var button, target;
    evt = evt || window.event;
    button = evt.which || evt.button;
    target = evt.target || evt.srcElement;
    if (evt.type === "click") {
      if (target) {
        processClick(_trackers[tracker], target, context);
      }
    } else if (evt.type === "mousedown") {
      if ((button === 1 || button === 2) && target) {
        _configuration[tracker].lastButton = button;
        _configuration[tracker].lastTarget = target;
      } else {
        _configuration[tracker].lastButton = _configuration[tracker].lastTarget = null;
      }
    } else if (evt.type === "mouseup") {
      if (button === _configuration[tracker].lastButton && target === _configuration[tracker].lastTarget) {
        processClick(_trackers[tracker], target, context);
      }
      _configuration[tracker].lastButton = _configuration[tracker].lastTarget = null;
    }
  };
}
function addClickListener(tracker, element) {
  if (_configuration[tracker].linkTrackingPseudoClicks) {
    addEventListener(element, "mouseup", getClickHandler(tracker, _configuration[tracker].linkTrackingContext), false);
    addEventListener(element, "mousedown", getClickHandler(tracker, _configuration[tracker].linkTrackingContext), false);
  } else {
    addEventListener(element, "click", getClickHandler(tracker, _configuration[tracker].linkTrackingContext), false);
  }
}
function configureLinkClickTracking(_a, tracker) {
  var _b = _a === void 0 ? {} : _a, options = _b.options, pseudoClicks = _b.pseudoClicks, trackContent = _b.trackContent, context = _b.context;
  _configuration[tracker] = {
    linkTrackingContent: trackContent,
    linkTrackingContext: context,
    linkTrackingPseudoClicks: pseudoClicks,
    linkTrackingFilter: getFilterByClass(options)
  };
}
function addClickListeners(trackerId) {
  var _a, _b;
  var linkElements = document.links, i;
  for (i = 0; i < linkElements.length; i++) {
    if (((_b = (_a = _configuration[trackerId]).linkTrackingFilter) === null || _b === void 0 ? void 0 : _b.call(_a, linkElements[i])) && !linkElements[i][trackerId]) {
      addClickListener(trackerId, linkElements[i]);
      linkElements[i][trackerId] = true;
    }
  }
}
export {
  LinkClickTrackingPlugin,
  enableLinkClickTracking,
  refreshLinkClickTracking,
  trackLinkClick
};
